import firebase from '@/plugins/firebase';

const db = firebase.firestore();

export async function getUniverseTenants({ commit, rootState }, universeId) {
  const tenantQuery = db
    .collection('universes')
    .doc(universeId)
    .collection('tenants')
    .get();

  if (rootState.user && rootState.user.user && rootState.user.user.email) {
    try {
      const universeTenants = await tenantQuery;
      if (universeTenants.docs.length) {
        commit('ADD_TENANTS', [].concat(universeTenants.docs));
      }

      // Listen for realtime updates
      universeTenants.onSnapshot((newTenant) => {
        if (newTenant.docs.length) {
          commit('ADD_TENANTS', [].concat(newTenant.docs));
        }
      });
    } catch (err) {
      console.warn('Tenants with direct access', err);
    }
  }
}

export async function getTenants({ dispatch }, universeId) {
  const userTenants = await dispatch('getUniverseTenants', universeId);
  return userTenants;
}
